module.exports = __webpack_public_path__ + "img/freeSendDesktopPage.035f94fd.jpg";